import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import Icon from '../../common/Icons';
import './ClinicalButtons.css';

const VARIANTS = new Set(['primary', 'save', 'view', 'secondary', 'danger', 'ghost']);

/**
 * Bouton clinique unifié — consultation, ordonnances, examens, orientations, certificats.
 *
 * @param {'primary'|'save'|'view'|'secondary'|'danger'|'ghost'} [variant]
 * @param {'sm'|'md'} [size]
 * @param {boolean} [loading]
 * @param {string} [icon] nom d’icône (Icons)
 * @param {'left'|'right'} [iconPosition]
 * @param {boolean} [block] pleine largeur
 * @param {boolean} [compact] padding réduit (actions inline)
 */
export default function ClinicalButton({
  variant = 'primary',
  size = 'sm',
  loading = false,
  icon,
  iconPosition = 'left',
  block = false,
  compact = false,
  className = '',
  children,
  disabled,
  type = 'button',
  ...props
}) {
  const safeVariant = VARIANTS.has(variant) ? variant : 'primary';
  const classes = [
    'cl-btn',
    `cl-btn--${safeVariant}`,
    size === 'md' ? 'cl-btn--md' : 'cl-btn--sm',
    block ? 'cl-btn--block' : '',
    compact ? 'cl-btn--compact' : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  const iconSize = compact ? 14 : size === 'md' ? 16 : 15;
  const iconEl = icon ? (
    <Icon name={icon} size={iconSize} className="cl-btn__icon" aria-hidden />
  ) : null;

  return (
    <Button
      type={type}
      className={classes}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <>
          <Spinner animation="border" size="sm" className="cl-btn__spinner" role="status" />
          {children ? <span className="cl-btn__label">{children}</span> : null}
        </>
      ) : (
        <>
          {icon && iconPosition === 'left' ? iconEl : null}
          {children ? <span className="cl-btn__label">{children}</span> : null}
          {icon && iconPosition === 'right' ? iconEl : null}
        </>
      )}
    </Button>
  );
}

/** Pile verticale de boutons d’action (panneaux consultation). */
export function ClinicalButtonStack({ className = '', children }) {
  return <div className={`cl-btn-stack${className ? ` ${className}` : ''}`}>{children}</div>;
}

/** Barre d’actions modale (imprimer · fermer). */
export function ClinicalModalActions({ className = '', children }) {
  return (
    <div className={`cl-modal-actions recv-no-print${className ? ` ${className}` : ''}`}>
      {children}
    </div>
  );
}
